import {useSearchParams} from 'react-router-dom'

export type TableSortOrder = 'asc' | 'desc'

export interface ITableSortQuery {
  sort?: string
  order?: TableSortOrder
}

// map: id ของคอลัมน์ใน _columns.tsx -> ชื่อฟิลด์ที่ API ใช้เรียงลำดับ
// คอลัมน์ที่ไม่อยู่ในนี้ (เช่น คำสั่ง, ค่าที่คำนวณหน้าบ้าน) จะกดเรียงลำดับไม่ได้
const TABLE_SORT_KEYS: {[columnId: string]: string} = {
  id: 'code',
  code: 'code',
  date: 'date',
  createdAt: 'date',
  expiryDate: 'expiryDate',
  expiryAt: 'expiryDate',
  expiredAt: 'expiryDate',
  taxCode: 'taxCode',
  totalAmount: 'totalAmount',
  netAmount: 'netAmount',
  vatPrice: 'vatPrice',
  fullName: 'labCompany',
  totalItems: 'totalItems',
  state: 'state',
}

// คอลัมน์ปุ่ม action ใช้ id ร่วมกับคอลัมน์สถานะ จึงต้องกันด้วยชื่อหัวตาราง
const ACTION_COLUMN_TITLES = ['คำสั่ง']

export const getTableSortKey = (columnId?: string, title?: string): string | undefined => {
  if (!columnId) return undefined
  if (title && ACTION_COLUMN_TITLES.includes(title)) return undefined

  return TABLE_SORT_KEYS[columnId]
}

// อ่านค่า sort ปัจจุบันจาก query string เพื่อส่งต่อให้ API
export const useTableSortQuery = (): ITableSortQuery => {
  const [searchParams] = useSearchParams()
  const sort = searchParams.get('sort') || undefined

  if (!sort) return {}

  return {sort, order: searchParams.get('order') === 'desc' ? 'desc' : 'asc'}
}

// กด 1 ครั้ง = น้อย->มาก, กดซ้ำ = มาก->น้อย, กดอีกครั้ง = ยกเลิกการเรียงลำดับ
export const useTableSort = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const {sort, order} = useTableSortQuery()

  const toggleSort = (sortKey: string) => {
    const nextParams = new URLSearchParams(searchParams)

    if (sort !== sortKey) {
      nextParams.set('sort', sortKey)
      nextParams.set('order', 'asc')
    } else if (order === 'asc') {
      nextParams.set('order', 'desc')
    } else {
      nextParams.delete('sort')
      nextParams.delete('order')
    }

    setSearchParams(nextParams, {replace: true})
  }

  return {sort, order, toggleSort}
}
